import { eldProviderLabel } from '@/components/Chat/ChatConfirmInformation'
import { InfoRow } from '@/components/Chat/ConfirmInfoCard'
import { ENTITY_TYPE_OPTIONS } from '@/components/Chat/useBusinessDetailsForm'
import { formatDate, formatPhone } from '@/lib/formatters'
import { formatAddress } from '@/models/address'
import { yearsInBusinessLabel } from '@/models/business'
import { maritalStatusLabel, type Org } from '@/models/user'

/** The Business card while it's closed: what's saved, as the old confirm step showed it. */
export function BusinessSummary({ organisation }: { organisation: Org }) {
  const carrier = organisation.business
  const application = organisation.currentInsuranceApplication
  const owner = application?.businessOwner
  const entityType = ENTITY_TYPE_OPTIONS.find((option) => option.value === application?.entityType)
  const ownerName = owner ? `${owner.firstName} ${owner.lastName}`.trim() : ''
  const freight = application?.commodities.map((item) => `${item.name} (${item.percentage}%)`) ?? []
  const distance = application?.travelDistance?.map((item) => item.label) ?? []

  return (
    <>
      <InfoRow label="Company name" value={carrier?.name || '-'} />
      <InfoRow label="DOT number" value={carrier?.dotNumber || '-'} />
      <InfoRow label="Business type" value={entityType?.label ?? '-'} />
      <InfoRow label="Address" value={formatAddress(carrier?.address)} />
      <InfoRow label="Years in business" value={yearsInBusinessLabel(carrier?.yearsInBusiness)} />
      <InfoRow label="ELD provider" value={eldProviderLabel(application?.hasEld, application?.eldProvider)} />
      {/* Only the questions the applicant was asked: the form shows these on the same conditions. */}
      {carrier?.address?.state === 'CA' && <InfoRow label="CA number" value={carrier.caNumber || '-'} />}
      {application?.coverageLapseDetected && (
        <InfoRow label="Reason for coverage lapse" value={application.cancellationReason || '-'} />
      )}
      <InfoRow label="Business owner" value={ownerName || '-'} />
      <InfoRow label="Owner email" value={owner?.email || '-'} />
      <InfoRow label="Owner phone" value={formatPhone(owner?.mobile) || '-'} />
      <InfoRow label="Owner date of birth" value={formatDate(owner?.dob)} />
      <InfoRow label="Owner marital status" value={maritalStatusLabel(owner?.maritalStatus)} />
      <InfoRow label="Travel distance" value={distance.join(', ') || '-'} />
      <InfoRow label="Freight" value={freight.join(', ') || '-'} />
    </>
  )
}
